import { DEFAULT_ANALYTICS_NAME } from './constants';
import track, { trackGA } from '../../services/track';
import { openLogin } from '../../services/regModal';

export const IS_13_OR_OVER_COOKIE_NAME = 'is13OrOver';
export const IS_STUDENT_COOKIE_NAME = 'isStudent';
export const IS_UNDER_13_COOKIE_NAME = 'isUnder13';
export const TEACHER_TYPE_COOKIE_NAME = 'teacher';

export function launchIfSwitchAccountCookieSet() {
  const name = 'switchAccounts';
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) {
    const email = match[2];
    // If user clicked "log in with different email" in my accounts modal, email will be set to '0'
    if (email !== '0' && email !== 'social') {
      openLogin(null, email);
    } else {
      openLogin(null, '');
    }
    document.cookie =
      'switchAccounts=; expires=' + new Date().toUTCString() + '; path=/';
  }
}

export function getCookieExpirationDate() {
  const d = new Date();
  d.setTime(d.getTime() + 15 * 60 * 1000);
  return d.toUTCString();
}

function setAgeGateCookie(name) {
  document.cookie = `${name}=1; expires=${getCookieExpirationDate()}; path=/`;
}

function deleteAgeGateCookie(name) {
  document.cookie = `${name}=1; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/`;
}

export function setIs13OrOverCookie() {
  setAgeGateCookie(IS_13_OR_OVER_COOKIE_NAME);
  deleteAgeGateCookie(IS_STUDENT_COOKIE_NAME);
  deleteAgeGateCookie(IS_UNDER_13_COOKIE_NAME);
}

export function setIsStudentCookie() {
  setAgeGateCookie(IS_STUDENT_COOKIE_NAME);
  deleteAgeGateCookie(IS_13_OR_OVER_COOKIE_NAME);
  deleteAgeGateCookie(IS_UNDER_13_COOKIE_NAME);
  deleteAgeGateCookie(TEACHER_TYPE_COOKIE_NAME);
}

export function setIsUnder13Cookie() {
  setAgeGateCookie(IS_UNDER_13_COOKIE_NAME);
  deleteAgeGateCookie(IS_13_OR_OVER_COOKIE_NAME);
  deleteAgeGateCookie(IS_STUDENT_COOKIE_NAME);
  deleteAgeGateCookie(TEACHER_TYPE_COOKIE_NAME);
}

export function setTeacherTypeCookie() {
  setAgeGateCookie(TEACHER_TYPE_COOKIE_NAME);
}

export function unsetTeacherTypeCookie() {
  deleteAgeGateCookie(TEACHER_TYPE_COOKIE_NAME);
}

export function dispatchCustomEvent(name) {
  let event;
  try {
    event = new CustomEvent(name);
  } catch (e) {
    // IE doesn't support CustomEvent as a constructor, so need to use this legacy method as a fallback
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(event, false, true, {});
  }
  document.dispatchEvent(event);
}

export function trackRegistration(event, name, method, gaDimensions) {
  let data = { section: DEFAULT_ANALYTICS_NAME, trigger: 'topnav' };
  if (method) data.method = method;

  data = { data, ...gaDimensions };
  track(name, data);
  trackGA(
    'modal',
    `${DEFAULT_ANALYTICS_NAME} registration modal: ${event}`,
    null,
    null,
    gaDimensions
  );
}
